module.exports = __webpack_public_path__ + "static/InteriorLandingHeroLiving-min-6b2aff63f777272b74d5aac862fd99c1.jpg";